(function () {
  'use strict';
  if (window.DSDOriginalsSocialCardLIBP01) return;
  var SERIES_ID = 'just-the-homie';
  var CHAPTERS = Object.freeze({
  "chapter-01": {
    "title": "Things We Don’t Say",
    "audioRevision": "chapter-01-v23-read-pronunciation-approved",
    "durationSeconds": 980.3295
  },
  "chapter-02": {
    "title": "Before You",
    "audioRevision": "chapter-02-founder-approved-2209025c4e72",
    "durationSeconds": 925.128
  },
  "chapter-03": {
    "title": "The Spare Key",
    "audioRevision": "chapter-03-founder-approved-4c907d94ce7f",
    "durationSeconds": 840.096
  },
  "chapter-04": {
    "title": "The Invitation",
    "audioRevision": "chapter-04-founder-approved-099c9fb5dc70",
    "durationSeconds": 1130.088
  },
  "chapter-05": {
    "title": "What We Keep",
    "audioRevision": "chapter-05-founder-approved-4f56d29b36db",
    "durationSeconds": 952.56
  },
  "chapter-06": {
    "title": "The Other Side of the Room",
    "audioRevision": "chapter-06-founder-approved-e790318a93ae",
    "durationSeconds": 934.176
  },
  "chapter-07": {
    "title": "Nothing on Hold",
    "audioRevision": "chapter-07-founder-approved-fbabe02788ea",
    "durationSeconds": 1020.24
  },
  "chapter-08": {
    "title": "Ask Me Again",
    "audioRevision": "chapter-08-founder-approved-346f6d0c9081",
    "durationSeconds": 982.872
  }
});
  var ENTRY_CHAPTER_ID = 'chapter-01';
  var ENDPOINT = '/apps/dsd-firebase-custom-token/originals';
  var audio = null;
  var activeCard = null;
  var visualTimer = 0;
  var inlineSessionId = null;
  var inlineScope = null;
  var inlineChapterId = null;
  var inlineAudioRevision = null;
  var playbackObserver = null;
  var authorizationGeneration = 0;
  var availabilityTimer = 0;
  var boundaryRefreshTimer = 0;
  var boundaryRefreshDueAt = 0;
  var availabilityGeneration = 0;
  var pageIdentityInvalid = false;
  var sharedReaderScope = null;
  var sharedAudioClaimed = false;
  var floatingPlayer = null;
  var floatingFrame = 0;

  function floatingControlCard() {
    if (!CHAPTERS[inlineChapterId] || !inlineScope) return null;
    if (!activeCard || activeCard.dataset.chapterId !== inlineChapterId) activeCard = cardFor({ type: 'chapter', seriesId: SERIES_ID, chapterId: inlineChapterId, canonicalUrl: canonical('chapter', inlineChapterId) });
    return activeCard;
  }

  function setFloatingText(selector, text) {
    var node = floatingPlayer.querySelector(selector);
    if (node.textContent !== text) node.textContent = text;
  }

  function mountFloatingPlayer() {
    if (floatingPlayer) return;
    var panel = document.createElement('aside');
    panel.className = 'dsd-originals-feed-player';
    panel.dataset.originalsFeedPlayer = 'true';
    panel.hidden = true;
    panel.setAttribute('aria-label', 'Audiobook player');
    panel.innerHTML = '<div class="dsd-originals-feed-player__heading"><strong data-originals-feed-title></strong><a data-originals-feed-open>Open chapter</a><button type="button" data-originals-feed-close aria-label="Stop audiobook and close player">×</button></div><div class="dsd-originals-feed-player__transport"><button type="button" data-originals-feed-toggle>Pause</button><input type="range" min="0" step="0.01" value="0" data-originals-feed-seek aria-label="Audiobook position"><span data-originals-feed-time></span></div>';
    document.body.appendChild(panel);
    floatingPlayer = panel;
    panel.querySelector('[data-originals-feed-toggle]').addEventListener('click', function () {
      if (!audio || !inlineChapterId) return;
      if (!audio.paused) { audio.pause(); updateFloatingPlayer(); }
      else { var card = floatingControlCard(); if (card) authorizeAndPlay(card, { keepDetached: true }); }
    });
    panel.querySelector('[data-originals-feed-close]').addEventListener('click', function () { clearActivePlayback(); updateCards(); });
    panel.querySelector('[data-originals-feed-seek]').addEventListener('change', function (event) {
      if (!audio) return;
      var card = floatingControlCard();
      if (!card) return;
      var target = Number(event.target.value);
      if (Number.isFinite(target)) authorizeAndPlay(card, { seekTo: target, resume: !audio.paused, keepDetached: true });
    });
    panel.querySelector('[data-originals-feed-open]').addEventListener('click', function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (window.DSDOriginalsInlineView && audio && inlineSessionId && inlineScope) { event.preventDefault(); openSharedReader(event.currentTarget); }
    });
  }

  function updateFloatingPlayer() {
    if (!floatingPlayer) return;
    var readerVisible = window.DSDOriginalsInlineView && window.DSDOriginalsInlineView.visible();
    var chapter = CHAPTERS[inlineChapterId];
    var eligible = !!(audio && chapter && inlineScope && audio.dataset.sourceReady === 'true' && !audio.ended && !readerVisible);
    var rect = activeCard && activeCard.isConnected !== false ? activeCard.getBoundingClientRect() : null;
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    var inView = rect && rect.bottom > 0 && rect.top < viewport;
    floatingPlayer.hidden = !eligible || !!inView;
    if (floatingPlayer.hidden) return;
    var dock = document.querySelector('.dsd-compact-dock');
    var dockRect = dock && dock.getBoundingClientRect();
    var bottom = dockRect && dockRect.height > 0 && dockRect.top < viewport ? Math.max(16, viewport - dockRect.top + 12) : 16;
    floatingPlayer.style.setProperty('--originals-feed-bottom', Math.ceil(bottom) + 'px');
    setFloatingText('[data-originals-feed-title]', 'Just the Homie · ' + chapter.title);
    floatingPlayer.querySelector('[data-originals-feed-open]').href = canonical('chapter', inlineChapterId);
    var play = floatingPlayer.querySelector('[data-originals-feed-toggle]');
    setFloatingText('[data-originals-feed-toggle]', audio.paused ? 'Play' : 'Pause');
    play.setAttribute('aria-label', audio.paused ? 'Resume audiobook' : 'Pause audiobook');
    var seek = floatingPlayer.querySelector('[data-originals-feed-seek]');
    seek.max = String(chapter.durationSeconds);
    if (!seek.matches(':active')) seek.value = String(audio.currentTime || 0);
    setFloatingText('[data-originals-feed-time]', formatTime(audio.currentTime || 0) + ' / ' + formatTime(chapter.durationSeconds));
  }

  function scheduleFloatingPlayer() {
    if (floatingFrame) return;
    floatingFrame = requestAnimationFrame(function () { floatingFrame = 0; updateFloatingPlayer(); });
  }

  function acquireSharedAudio(root, config) {
    var binding = pageBinding();
    if (!window.DSDOriginalsInlineView || !window.DSDOriginalsInlineView.isRoot(root) || !binding || !config ||
        config.signedIn !== binding.signedIn || binding.signedIn && config.requestScope !== binding.readerScope ||
        !audio || audio.dataset.sourceReady !== 'true' || !inlineSessionId || !inlineScope || sharedReaderScope !== inlineScope ||
        !Array.isArray(config.chapters) || !config.chapters.some(function (chapter) { return chapter.id === inlineChapterId && chapter.audioRevision === inlineAudioRevision; })) return null;
    sharedAudioClaimed = true;
    var bindingScope = inlineScope;
    return {
      audio: audio, observer: playbackObserver, scope: inlineScope,
      getSessionId: function () { return inlineSessionId; },
      setSessionId: function (value) { inlineSessionId = value; },
      matches: function (chapterId, revision) {
        var next = pageBinding();
        return Boolean(next && next.signedIn === binding.signedIn && next.readerScope === binding.readerScope &&
          inlineScope === bindingScope && inlineChapterId === chapterId && inlineAudioRevision === revision);
      },
      adoptChapter: function (session, chapter) {
        var next = pageBinding();
        if (!next || next.signedIn !== binding.signedIn || next.readerScope !== binding.readerScope ||
            session.playbackScope !== bindingScope || session.chapterId !== chapter.id || session.audioRevision !== chapter.audioRevision ||
            !config.chapters.some(function (item) { return item.id === chapter.id && item.audioRevision === chapter.audioRevision; })) return false;
        if ((inlineChapterId !== chapter.id || inlineAudioRevision !== chapter.audioRevision) && !window.DSDOriginalsInlineView.visible()) return false;
        if (activeCard && activeCard.dataset.chapterId !== chapter.id) {
          status(activeCard, 'Audio loads only after Play.', 'ready');
          activeCard = null;
        }
        inlineScope = bindingScope; sharedReaderScope = bindingScope;
        inlineChapterId = chapter.id; inlineAudioRevision = chapter.audioRevision;
        updateCards();
        return true;
      },
      visible: window.DSDOriginalsInlineView.visible,
      invalidate: function () { clearActivePlayback(); }
    };
  }

  function openSharedReader(open) {
    var binding = pageBinding(), chapterId = inlineChapterId, revision = inlineAudioRevision, scope = inlineScope;
    var generation = authorizationGeneration;
    if (!binding || !chapterId || !revision || !scope) return Promise.resolve();
    function current() {
      var next = pageBinding();
      return generation === authorizationGeneration && next && next.signedIn === binding.signedIn && next.readerScope === binding.readerScope &&
        inlineScope === scope && inlineChapterId === chapterId && inlineAudioRevision === revision;
    }
    var query = '?chapterId=' + encodeURIComponent(chapterId) + '&audioRevision=' + encodeURIComponent(revision);
    return fetch(ENDPOINT + '/session' + query, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ readerScope: binding.readerScope }) }).then(function (response) {
      if (!response.ok) { var error = new Error('shared_reader_access'); error.status = response.status; throw error; }
      return response.json();
    }).then(function (session) {
      if (!current() || !session || session.playbackScope !== scope || session.chapterId !== chapterId || session.audioRevision !== revision || !sameMediaUrl(audio, session.mediaUrl)) throw new Error('shared_reader_changed');
      sharedReaderScope = scope;
      return window.DSDOriginalsInlineView.open({ url: open.href, chapterId: chapterId, audioRevision: revision, signedIn: binding.signedIn, readerScope: binding.readerScope, current: current });
    }).catch(function (error) {
      if (!current()) return;
      if (error && [401,403,404,409].includes(error.status)) clearActivePlayback('Access changed. Reload to check this chapter.', 'unavailable');
      else status(activeCard, 'The full reader could not open. Audio stays here; try again.', 'error');
    });
  }

  function pageBinding() {
    if (pageIdentityInvalid) return null;
    var node = document.querySelector('[data-originals-config]') || document.querySelector('[data-originals-account-context]');
    if (!node) return null;
    try {
      var config = JSON.parse(node.textContent);
      if (config.signedIn === true && /^[a-f0-9]{64}$/.test(String(config.requestScope || ''))) return { signedIn: true, readerScope: config.requestScope };
      if (config.signedIn === false) return { signedIn: false, readerScope: 'guest-page-v1' };
    } catch (_error) {}
    return null;
  }

  function playbackSessionId() {
    return window.crypto && typeof window.crypto.randomUUID === 'function' ? window.crypto.randomUUID() : null;
  }

  function canonical(type, chapterId) {
    if (window.DSDOriginalsRoutes) {
      var routes = window.DSDOriginalsRoutes.read(document.querySelector('[data-originals-public-routes]'));
      return new URL(window.DSDOriginalsRoutes.href({ view: type, seriesId: SERIES_ID, chapterId: type === 'chapter' ? (CHAPTERS[chapterId] ? chapterId : ENTRY_CHAPTER_ID) : '' }, routes), location.origin).toString();
    }
    var url = new URL('/', location.origin);
    url.searchParams.set('view', type);
    url.searchParams.set('series', SERIES_ID);
    if (type === 'chapter') url.searchParams.set('chapter', CHAPTERS[chapterId] ? chapterId : ENTRY_CHAPTER_ID);
    return url.toString();
  }

  function referenceFromUrl(value) {
    var url;
    try { url = new URL(value, location.origin); } catch (error) { return null; }
    if (url.origin !== location.origin) return null;
    if (window.DSDOriginalsRoutes) {
      var routes = window.DSDOriginalsRoutes.read(document.querySelector('[data-originals-public-routes]'));
      if (window.DSDOriginalsRoutes.publicPath(url.pathname, routes)) {
        var route = window.DSDOriginalsRoutes.parse(url.search, url.pathname, routes);
        if (route.seriesId !== SERIES_ID || !['series', 'chapter'].includes(route.view) || route.view === 'chapter' && !CHAPTERS[route.chapterId]) return null;
        return { type: route.view, seriesId: SERIES_ID, chapterId: route.view === 'chapter' ? route.chapterId : null, canonicalUrl: canonical(route.view, route.chapterId) };
      }
    }
    if (url.origin !== location.origin || url.pathname !== '/' || url.searchParams.get('series') !== SERIES_ID) return null;
    var view = url.searchParams.get('view');
    if (!['series', 'chapter'].includes(view)) return null;
    var chapterId = url.searchParams.get('chapter') || '';
    if (view === 'chapter' && !CHAPTERS[chapterId]) return null;
    return { type: view, seriesId: SERIES_ID, chapterId: view === 'chapter' ? chapterId : null, canonicalUrl: canonical(view, chapterId) };
  }

  function referenceFromData(value) {
    if (!value || typeof value !== 'object' || value.version !== 1 || value.seriesId !== SERIES_ID) return null;
    var keys = Object.keys(value).sort().join(',');
    if (value.type === 'series' && keys === 'seriesId,type,version') return { type: 'series', seriesId: SERIES_ID, chapterId: null, canonicalUrl: canonical('series') };
    if (value.type === 'chapter' && keys === 'chapterId,seriesId,type,version' && CHAPTERS[value.chapterId]) return { type: 'chapter', seriesId: SERIES_ID, chapterId: value.chapterId, canonicalUrl: canonical('chapter', value.chapterId) };
    return null;
  }

  function status(card, message, kind) {
    var node = card && card.querySelector('[data-originals-card-status]');
    if (node) node.textContent = message;
    if (card) card.dataset.originalsCardState = kind || 'ready';
  }

  function applyAvailability(card, availability) {
    if (!card) return;
    if (availability !== 'available' && activeCard === card) clearActivePlayback();
    if (card.isConnected === false) return;
    var button = card.querySelector('[data-originals-inline-play]');
    if (card.dataset.originalsRevisionStale === 'true') {
      if (button) button.disabled = true;
      status(card, 'This chapter changed. Open it for the latest version.', 'unavailable');
      return;
    }
    var summary = card.querySelector('[data-originals-card-summary]');
    var chapterId = card.dataset.chapterId;
    var chapter = CHAPTERS[chapterId];
    var withdrawn = availability === 'unavailable';
    card.dataset.originalsAvailability = availability;
    if (button) button.disabled = availability !== 'available';
    if (summary && chapter) summary.textContent = withdrawn
      ? 'This chapter is unavailable.'
      : card.dataset.originalsReferenceType === 'series'
        ? 'A Metro Detroit romantic drama about love, jealousy, and honesty.'
        : chapter.title + ' · ' + formatTime(chapter.durationSeconds) + ' audio';
    // A changed policy is not a pause control: release buffered inline audio
    // and its handoff scope before disabling the card's Play button.
    if (availability !== 'available' && activeCard === card) clearActivePlayback();
    if (availability === 'available') {
      if (activeCard !== card || !audio || audio.paused) status(card, 'Audio loads only after Play.', 'ready');
    } else if (availability === 'sign_in') status(card, 'Sign in to listen.', 'locked');
    else if (availability === 'dsd_plus') status(card, 'DSD+ access is required.', 'locked');
    else status(card, 'This chapter is unavailable.', 'unavailable');
  }

  function refreshAvailability() {
    availabilityTimer = 0;
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-originals-inline-card]'));
    if (activeCard && cards.indexOf(activeCard) < 0) cards.push(activeCard);
    var ids = Array.from(new Set(cards.map(function (card) { return card.dataset.chapterId; }).filter(function (id) { return !!CHAPTERS[id]; }))).slice(0, 8);
    if (!ids.length) { clearTimeout(boundaryRefreshTimer); boundaryRefreshTimer = 0; return Promise.resolve(); }
    var generation = ++availabilityGeneration;
    cards.forEach(function (card) {
      if (card.isConnected === false) return;
      var button = card.querySelector('[data-originals-inline-play]');
      if (button) button.disabled = true;
      if (activeCard !== card || !audio || audio.paused) status(card, 'Checking availability…', 'loading');
    });
    return fetch(ENDPOINT + '/reference-status?format=audio&chapterIds=' + encodeURIComponent(ids.join(',')), {
      credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('reference_status_unavailable');
      return response.json();
    }).then(function (body) {
      if (generation !== availabilityGeneration) return;
      if (!body || !Array.isArray(body.rows) || !(body.version === 2 && body.format === 'audio' || body.version === 1)) throw new Error('reference_status_invalid');
      var byId = Object.create(null);
      body.rows.forEach(function (row) {
        if (row && ids.includes(row.chapterId) && ['available', 'sign_in', 'dsd_plus', 'unavailable'].includes(row.availability)) byId[row.chapterId] = row.availability;
      });
      cards.forEach(function (card) { applyAvailability(card, byId[card.dataset.chapterId] || 'unavailable'); });
      scheduleBoundaryRefresh(body.version === 2 ? body.refreshAfterSeconds : 60);
    }).catch(function () {
      if (generation !== availabilityGeneration) return;
      if (activeCard && audio) clearActivePlayback();
      cards.forEach(function (card) {
        if (card.isConnected === false) return;
        var button = card.querySelector('[data-originals-inline-play]');
        if (button) button.disabled = false;
        card.dataset.originalsAvailability = 'unknown';
        if (activeCard !== card || !audio || audio.paused) status(card, 'Availability could not be checked. Play to retry.', 'error');
      });
      scheduleBoundaryRefresh(60);
    });
  }

  function scheduleBoundaryRefresh(seconds) {
    if (boundaryRefreshTimer) clearTimeout(boundaryRefreshTimer);
    boundaryRefreshTimer = 0;
    boundaryRefreshDueAt = 0;
    // Background audio may continue. Keep its access check alive even when
    // idle cards stop polling; browser timer throttling remains a limitation.
    if (document.visibilityState === 'hidden' && (!activeCard || !audio || audio.paused)) return;
    var delay = Number(seconds);
    delay = Number.isFinite(delay) ? Math.max(1, Math.min(60, Math.floor(delay))) : 60;
    boundaryRefreshDueAt = Date.now() + delay * 1000;
    boundaryRefreshTimer = setTimeout(refreshAvailability, delay * 1000);
  }

  function scheduleAvailability() {
    // Invalidate an in-flight result immediately on an identity or page-state
    // change, before the short coalescing delay can start the next request.
    availabilityGeneration++;
    if (availabilityTimer) clearTimeout(availabilityTimer);
    if (boundaryRefreshTimer) clearTimeout(boundaryRefreshTimer);
    boundaryRefreshTimer = 0;
    boundaryRefreshDueAt = 0;
    availabilityTimer = setTimeout(refreshAvailability, 50);
  }

  function ensureAudio() {
    if (audio) return audio;
    audio = document.createElement('audio');
    audio.preload = 'none';
    audio.dataset.dsdOriginalsInlineAudio = 'true';
    document.body.appendChild(audio);
    audio.addEventListener('play', function () {
      document.querySelectorAll('audio').forEach(function (media) { if (media !== audio && !media.paused) media.pause(); });
      if (window.DSDGMOR && typeof window.DSDGMOR.claimExternalAudio === 'function') window.DSDGMOR.claimExternalAudio(audio);
      else if (window.DSDGMOR && typeof window.DSDGMOR.pauseActive === 'function') window.DSDGMOR.pauseActive('originals-inline-play');
      window.dispatchEvent(new CustomEvent('dsd:originals:inline-playback', { detail: { state: 'playing', chapterId: inlineChapterId } }));
      startVisuals();
    });
    audio.addEventListener('playing', function () { if (!inlineSessionId) inlineSessionId = playbackSessionId(); });
    if (window.DSDOriginalsPlaybackObserver) playbackObserver = window.DSDOriginalsPlaybackObserver.create(audio, { sessionId: function () { return inlineSessionId; }, requireAccountScope: true });
    audio.addEventListener('pause', function () {
      if (window.DSDGMOR && typeof window.DSDGMOR.releaseExternalAudio === 'function') window.DSDGMOR.releaseExternalAudio(audio);
      if (activeCard && !audio.ended) status(activeCard, 'Paused', 'paused');
      updateCards(); stopVisuals();
      if (document.visibilityState === 'hidden' && boundaryRefreshTimer) {
        clearTimeout(boundaryRefreshTimer);
        boundaryRefreshTimer = 0;
        boundaryRefreshDueAt = 0;
      }
    });
    audio.addEventListener('ended', function () { if (window.DSDGMOR && typeof window.DSDGMOR.releaseExternalAudio === 'function') window.DSDGMOR.releaseExternalAudio(audio); updateCards(); stopVisuals(); if (!sharedAudioClaimed) inlineSessionId = null; });
    audio.addEventListener('error', function () { clearActivePlayback('Audio could not be loaded. Try again.', 'error'); });
    document.addEventListener('play', function (event) { if (event.target !== audio && audio && !audio.paused && !(event.target.tagName === 'VIDEO' && event.target.muted)) audio.pause(); }, true);
    return audio;
  }

  function startVisuals() {
    stopVisuals();
    function tick() { updateCards(); if (audio && !audio.paused) visualTimer = requestAnimationFrame(tick); }
    visualTimer = requestAnimationFrame(tick);
  }
  function stopVisuals() { if (visualTimer) cancelAnimationFrame(visualTimer); visualTimer = 0; }

  function updateCards() {
    document.querySelectorAll('[data-originals-inline-card]').forEach(function (card) {
      var button = card.querySelector('[data-originals-inline-play]');
      var seek = card.querySelector('[data-originals-inline-seek]');
      var time = card.querySelector('[data-originals-inline-time]');
      var ownsChapter = Boolean(activeCard === card && card.dataset.chapterId === inlineChapterId);
      var current = Boolean(audio && ownsChapter && !audio.paused);
      if (button) button.textContent = current ? 'Pause' : 'Play';
      if (audio && ownsChapter) {
        if (seek) { seek.max = String(Number.isFinite(audio.duration) ? audio.duration : CHAPTERS[inlineChapterId || ENTRY_CHAPTER_ID].durationSeconds); seek.value = String(audio.currentTime || 0); }
        if (time) time.textContent = formatTime(audio.currentTime || 0);
      }
    });
    updateFloatingPlayer();
  }

  function formatTime(seconds) {
    var value = Math.max(0, Math.floor(Number(seconds) || 0));
    return Math.floor(value / 60) + ':' + String(value % 60).padStart(2, '0');
  }

  function sameMediaUrl(player, url) {
    try { return new URL(player.currentSrc || player.src, location.origin).href === new URL(url, location.origin).href; }
    catch (error) { return false; }
  }

  function clearAudioSource(player) {
    if (typeof player.removeAttribute === 'function') player.removeAttribute('src');
    else player.src = '';
    player.dataset.sourceReady = 'false';
    player.load();
  }

  function clearActivePlayback(message, kind) {
    var card = activeCard;
    ++authorizationGeneration;
    if (playbackObserver) playbackObserver.flush();
    if (audio) {
      if (!audio.paused) audio.pause();
      clearAudioSource(audio);
    }
    stopVisuals();
    activeCard = null;
    inlineScope = null;
    inlineSessionId = null;
    inlineChapterId = null;
    inlineAudioRevision = null;
    sharedReaderScope = null;
    sharedAudioClaimed = false;
    updateFloatingPlayer();
    if (card && card.isConnected !== false && message) status(card, message, kind);
  }

  function releaseDetachedCard() {
    if (!activeCard || activeCard.isConnected !== false) return;
    if (audio && inlineChapterId && inlineScope && audio.dataset.sourceReady === 'true') scheduleFloatingPlayer();
    else clearActivePlayback();
  }

  function authorizeAndPlay(card, options) {
    if (card.dataset.originalsRevisionStale === 'true') return Promise.resolve();
    var binding = pageBinding();
    if (!binding) { clearActivePlayback(); status(card, 'Reload to check your current account.', 'unavailable'); return Promise.resolve(); }
    var player = ensureAudio();
    var chapterId = CHAPTERS[card.dataset.chapterId] ? card.dataset.chapterId : ENTRY_CHAPTER_ID;
    var chapter = CHAPTERS[chapterId];
    var seeking = !!options && Number.isFinite(options.seekTo);
    var resume = !seeking || options.resume === true;
    var sameCard = activeCard === card;
    var generation = ++authorizationGeneration;
    if (!player.paused) {
      player.pause();
      if (sameCard && !seeking) return Promise.resolve();
    }
    activeCard = card;
    // A cached media element is not proof that this viewer still has access.
    // Recheck on every deliberate resume without replacing the stream when
    // the protected media endpoint and actor scope are unchanged.
    status(card, 'Checking access…', 'loading');
    var query = '?chapterId=' + encodeURIComponent(chapterId) + '&audioRevision=' + encodeURIComponent(chapter.audioRevision);
    return fetch(ENDPOINT + '/session' + query, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ readerScope: binding.readerScope }) }).then(function (response) {
      if (!response.ok) { var error = new Error('access'); error.status = response.status; throw error; }
      return response.json();
    }).then(function (session) {
      if (generation !== authorizationGeneration) return;
      var currentBinding = pageBinding();
      if (!currentBinding || currentBinding.signedIn !== binding.signedIn || currentBinding.readerScope !== binding.readerScope) { clearActivePlayback(); return; }
      if (card.isConnected === false && !(options && options.keepDetached === true && inlineChapterId === chapterId && inlineScope)) { releaseDetachedCard(); return; }
      if (!session || !session.mediaUrl || session.chapterId !== chapterId || session.audioRevision !== chapter.audioRevision) throw new Error('session_invalid');
      var nextScope = typeof session.playbackScope === 'string' ? session.playbackScope : null;
      if (inlineScope && (inlineScope !== nextScope || inlineChapterId !== chapterId || inlineAudioRevision !== chapter.audioRevision)) {
        inlineSessionId = null;
        player.currentTime = 0;
      }
      inlineScope = nextScope;
      inlineChapterId = chapterId;
      inlineAudioRevision = chapter.audioRevision;
      if (playbackObserver) playbackObserver.setContext({ enabled: session.measurementEnabled === true, chapterId: chapterId, audioRevision: chapter.audioRevision, progressScope: session.progressScope });
      if (player.dataset.sourceReady !== 'true' || !sameMediaUrl(player, session.mediaUrl)) {
        player.src = session.mediaUrl;
        player.preload = 'metadata';
        player.dataset.sourceReady = 'true';
        player.load();
      }
      if (seeking) {
        player.currentTime = Math.max(0, Math.min(options.seekTo, Number.isFinite(player.duration) ? player.duration : chapter.durationSeconds));
        updateCards();
      }
      if (resume) return player.play();
    }).then(function () {
      if (generation === authorizationGeneration) status(card, resume ? 'Playing ' + chapter.title : 'Paused', resume ? 'playing' : 'paused');
    }).catch(function (error) {
      if (generation !== authorizationGeneration) return;
      // An uncertain renewal is not permission to keep a cached signed source
      // or hand the previous listening scope to the full player.
      player.pause();
      clearAudioSource(player);
      inlineScope = null;
      inlineSessionId = null;
      inlineChapterId = null;
      inlineAudioRevision = null;
      if (error && [401, 403, 404, 409].includes(error.status)) {
        var button = card.querySelector('[data-originals-inline-play]');
        if (button) button.disabled = true;
        card.dataset.originalsAvailability = error.status === 401 ? 'sign_in' : error.status === 403 ? 'dsd_plus' : 'unavailable';
        if (error.status === 409) card.dataset.originalsRevisionStale = 'true';
      }
      if (error && error.name === 'NotAllowedError') status(card, 'Use Play again to continue.', 'paused');
      else if (error && error.status === 401) status(card, 'Sign in to listen.', 'locked');
      else if (error && error.status === 403) status(card, 'DSD+ access is required.', 'locked');
      else if (error && error.status === 404) applyAvailability(card, 'unavailable');
      else if (error && error.status === 409) status(card, 'This chapter changed. Open it for the latest version.', 'unavailable');
      else status(card, 'Audio is unavailable right now.', 'error');
    });
  }

  function coverFor(context) {
    var routes; try { routes = JSON.parse((document.querySelector('[data-originals-public-routes]') || {}).textContent || '{}'); } catch (_error) { return null; }
    var square = context !== 'message' && typeof routes.postArtwork === 'string';
    var source = square ? routes.postArtwork : routes.artwork;
    if (typeof source !== 'string') return null;
    var url; try { url = new URL(source, location.origin); } catch (_error) { return null; }
    var filename = square ? 'dsd-just-the-homie-cover-r1124.jpg' : 'dsd-just-the-homie-cover-r1132.jpg';
    if (url.protocol !== 'https:' || !['cdn.shopify.com', location.hostname].includes(url.hostname) || !url.pathname.endsWith('/' + filename)) return null;
    var image = document.createElement('img'); image.src = url.href; image.alt = 'Just the Homie'; image.width = 900; image.height = square ? 900 : 1125; image.loading = 'lazy'; image.decoding = 'async'; image.className = 'dsd-originals-inline-card__cover';
    return image;
  }

  function cardFor(ref) {
    var chapterId = ref.type === 'chapter' ? ref.chapterId : ENTRY_CHAPTER_ID;
    var chapter = CHAPTERS[chapterId];
    var card = document.createElement('aside');
    card.className = 'dsd-originals-inline-card';
    card.dataset.originalsInlineCard = 'true';
    card.dataset.seriesId = ref.seriesId;
    card.dataset.chapterId = chapterId;
    card.dataset.originalsReferenceType = ref.type;
    card.dataset.originalsReferenceUrl = ref.canonicalUrl;
    var eyebrow = document.createElement('span'); eyebrow.className = 'dsd-originals-inline-card__eyebrow'; eyebrow.textContent = 'DSD Originals';
    var title = document.createElement('strong'); title.textContent = ref.type === 'chapter' ? 'Just the Homie — Chapter ' + Number(chapterId.slice(-2)) : 'Just the Homie';
    var summary = document.createElement('p'); summary.dataset.originalsCardSummary = 'true'; summary.textContent = ref.type === 'chapter' ? chapter.title + ' · ' + formatTime(chapter.durationSeconds) + ' audio' : 'A Metro Detroit romantic drama about love, jealousy, and honesty.';
    var controls = document.createElement('div'); controls.className = 'dsd-originals-inline-card__controls';
    var play = document.createElement('button'); play.type = 'button'; play.dataset.originalsInlinePlay = 'true'; play.textContent = ref.type === 'series' ? 'Play Chapter One' : 'Play';
    var range = document.createElement('input'); range.type = 'range'; range.min = '0'; range.max = String(chapter.durationSeconds); range.step = '.01'; range.value = '0'; range.dataset.originalsInlineSeek = 'true'; range.setAttribute('aria-label', 'Chapter position');
    var time = document.createElement('span'); time.dataset.originalsInlineTime = 'true'; time.textContent = '0:00';
    controls.append(play, range, time);
    var open = document.createElement('a'); open.href = ref.canonicalUrl; open.textContent = ref.type === 'chapter' ? 'Open chapter' : 'Open series'; open.dataset.originalsInlineOpen = 'true';
    controls.appendChild(open);
    var state = document.createElement('span'); state.className = 'dsd-originals-inline-card__status'; state.dataset.originalsCardStatus = 'true'; state.setAttribute('aria-live', 'polite'); state.textContent = 'Audio loads only after Play.';
    var cover = coverFor(); if (cover) card.appendChild(cover);
    card.append(eyebrow, title, summary, controls, state);
    return card;
  }

  function enhance(root) {
    var scope = root || document; var slots = []; var added = false;
    if (scope.matches && scope.matches('[data-originals-post-reference]')) slots.push(scope);
    slots = slots.concat(Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll('[data-originals-post-reference]') : []));
    slots.forEach(function (slot) {
      var post = slot.closest('.dsd-post-card'); if (!post) return;
      var data; try { data = JSON.parse(slot.getAttribute('data-originals-post-reference') || 'null'); } catch (error) { data = null; }
      var ref = referenceFromData(data);
      if (!ref) { slot.textContent = 'Originals reference unavailable.'; return; }
      var duplicate = Array.prototype.some.call(post.querySelectorAll('[data-originals-inline-card]'), function (card) { return card.dataset.originalsReferenceUrl === ref.canonicalUrl; });
      if (duplicate) { slot.remove(); return; }
      slot.replaceWith(cardFor(ref)); added = true;
      Array.prototype.forEach.call(post.querySelectorAll('a.dsd-post-card__link-preview'), function (preview) {
        var previewRef = referenceFromUrl(preview.href);
        if (previewRef && previewRef.canonicalUrl === ref.canonicalUrl) preview.remove();
      });
    });
    var links = [];
    if (scope.matches && scope.matches('a[href]')) links.push(scope);
    links = links.concat(Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll('a[href]') : []));
    links.forEach(function (link) {
      if (link.dataset.originalsReferenceEnhanced === 'true' || link.closest('[data-originals-inline-card]')) return;
      var message = link.closest('.dsd-msg384__bubble:not(.is-placeholder)');
      if (message && link.closest('p')) {
        var messageRef = referenceFromUrl(link.href);
        if (!messageRef) return;
        link.dataset.originalsReferenceEnhanced = 'true';
        var messageBody = link.closest('p');
        if (messageBody.parentElement.querySelector('[data-originals-message-preview]')) return;
        var messageCover = coverFor('message'); if (!messageCover) return;
        var previewLink = document.createElement('a'); previewLink.href = messageRef.canonicalUrl; previewLink.dataset.originalsMessagePreview = 'true'; previewLink.className = 'dsd-originals-message-preview';
        var previewTitle = document.createElement('span'); previewTitle.textContent = messageRef.type === 'series' ? 'Just the Homie' : 'Just the Homie — ' + CHAPTERS[messageRef.chapterId].title;
        previewLink.append(messageCover, previewTitle); messageBody.insertAdjacentElement('afterend', previewLink); return;
      }
      var paragraph = link.closest('p.dsd-post-card__body, p.dsd-shared-post__body');
      var post = paragraph && paragraph.closest('.dsd-post-card');
      if (!post) return;
      var ref = referenceFromUrl(link.href); if (!ref) return;
      link.dataset.originalsReferenceEnhanced = 'true';
      var duplicate = Array.prototype.some.call(post.querySelectorAll('[data-originals-inline-card]'), function (card) { return card.dataset.originalsReferenceUrl === ref.canonicalUrl; });
      if (duplicate) return;
      var card = cardFor(ref);
      paragraph.insertAdjacentElement('afterend', card); added = true;
      Array.prototype.forEach.call(post.querySelectorAll('a.dsd-post-card__link-preview'), function (preview) {
        var previewRef = referenceFromUrl(preview.href);
        if (previewRef && previewRef.canonicalUrl === ref.canonicalUrl) preview.remove();
      });
    });
    if (added) scheduleAvailability();
  }

  function showComposerHandoffStatus(ref, chapterId) {
    var host = document.querySelector('#MainContent') || document.body;
    if (!host) return;
    var notice = host.querySelector('[data-originals-composer-status]');
    if (!notice) {
      notice = document.createElement('p');
      notice.dataset.originalsComposerStatus = 'true';
      notice.className = 'dsd-originals-composer-status';
      notice.setAttribute('role', 'status');
      host.prepend(notice);
    }
    notice.textContent = 'This story was not attached to a post. Posting is unavailable right now. Check your profile, or return to the story and try again. ';
    var profile = document.createElement('a'); profile.href = '/pages/user-profile'; profile.textContent = 'Open profile';
    var story = document.createElement('a'); story.href = canonical(ref, chapterId); story.textContent = 'Return to story';
    notice.append(profile, ' · ', story);
  }

  function openComposerFromQuery() {
    var params = new URLSearchParams(location.search);
    if (params.get('compose') !== 'originals' || params.get('series') !== SERIES_ID) return;
    var ref = params.get('ref') === 'series' ? 'series' : 'chapter';
    var chapterId = params.get('chapter');
    if (ref === 'chapter' && !CHAPTERS[chapterId]) return;
    var attempts = 0;
    var opened = false;
    var timer = setInterval(function () {
      attempts += 1;
      var postingPolicy = window.DSDViewerPolicy;
      if (!postingPolicy || typeof postingPolicy.canCreatePost !== 'function' || !postingPolicy.canCreatePost()) {
        if (attempts >= 80) { clearInterval(timer); showComposerHandoffStatus(ref, chapterId); }
        return;
      }
      var trigger = document.querySelector('[data-dsd-create-post-modal="true"]');
      if (trigger && !opened && !trigger.disabled) { trigger.click(); opened = true; }
      var field = document.querySelector('[data-dsd-global-post-composer] textarea[name="body"]');
      if (field) {
        var form = field.closest('[data-dsd-global-post-composer]');
        var reference = ref === 'chapter'
          ? { version: 1, type: 'chapter', seriesId: SERIES_ID, chapterId: chapterId }
          : { version: 1, type: 'series', seriesId: SERIES_ID };
        form.dataset.originalsReference = JSON.stringify(reference);
        var prior = form.querySelector('[data-originals-composer-attachment]'); if (prior) prior.remove();
        var preview = document.createElement('div'); preview.dataset.originalsComposerAttachment = 'true'; preview.className = 'dsd-originals-composer-attachment';
        var label = document.createElement('span'); label.textContent = ref === 'chapter' ? 'Attached: Just the Homie — ' + CHAPTERS[chapterId].title : 'Attached: Just the Homie series';
        var remove = document.createElement('button'); remove.type = 'button'; remove.dataset.originalsRemoveAttachment = 'true'; remove.textContent = 'Remove';
        var cover = coverFor(); if (cover) preview.appendChild(cover);
        preview.append(label, remove); field.insertAdjacentElement('beforebegin', preview);
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.focus();
        clearInterval(timer);
        ['compose','ref','series','chapter'].forEach(function (key) { params.delete(key); });
        history.replaceState(history.state, '', location.pathname + (params.toString() ? '?' + params.toString() : '') + location.hash);
      } else if (attempts >= 80) { clearInterval(timer); showComposerHandoffStatus(ref, chapterId); }
    }, 150);
  }

  document.addEventListener('click', function (event) {
    var removeAttachment = event.target.closest('[data-originals-remove-attachment]');
    if (removeAttachment) {
      var composer = removeAttachment.closest('[data-dsd-global-post-composer]');
      if (composer) delete composer.dataset.originalsReference;
      removeAttachment.closest('[data-originals-composer-attachment]').remove();
      return;
    }
    var play = event.target.closest('[data-originals-inline-play]');
    if (play) { event.preventDefault(); authorizeAndPlay(play.closest('[data-originals-inline-card]')); return; }
    var seek = event.target.closest('[data-originals-inline-seek]');
    if (seek && event.type === 'click') event.stopPropagation();
    var open = event.target.closest('[data-originals-inline-open]');
    if (open && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && (!event.button || event.button === 0) &&
        window.DSDOriginalsInlineView && audio && activeCard === open.closest('[data-originals-inline-card]') && inlineSessionId && inlineScope) {
      event.preventDefault(); openSharedReader(open); return;
    }
    if (open && audio && activeCard === open.closest('[data-originals-inline-card]') && inlineSessionId && inlineScope) {
      sessionStorage.setItem('dsd-originals-inline-handoff-v1', JSON.stringify({ chapterId: inlineChapterId, audioRevision: inlineAudioRevision, sessionId: inlineSessionId, playbackScope: inlineScope, positionSeconds: audio.currentTime || 0, playing: !audio.paused, savedAt: Date.now() }));
    }
  });
  document.addEventListener('change', function (event) {
    var seek = event.target.closest('[data-originals-inline-seek]');
    if (seek && audio && activeCard === seek.closest('[data-originals-inline-card]')) {
      var target = Number(seek.value);
      if (Number.isFinite(target)) authorizeAndPlay(activeCard, {
        seekTo: Math.max(0, Math.min(target, Number.isFinite(audio.duration) ? audio.duration : CHAPTERS[inlineChapterId || ENTRY_CHAPTER_ID].durationSeconds)),
        resume: !audio.paused
      });
    }
  });
  window.addEventListener('pagehide', function () { if (playbackObserver) playbackObserver.flush(); });
  ['dsd:shopify-account:changed', 'dsd:shopify-logout'].forEach(function (name) {
    window.addEventListener(name, function () {
      pageIdentityInvalid = true;
      try { sessionStorage.removeItem('dsd-originals-inline-handoff-v1'); } catch (_error) { /* Storage may be unavailable. */ }
      clearActivePlayback('Account changed. Play to check current access.', 'paused');
      scheduleAvailability();
    });
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) clearActivePlayback('Rechecking current access.', 'loading');
    scheduleAvailability();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      // Background timers may be suspended. Do not keep playing a buffered
      // source across a policy-check boundary that elapsed while hidden.
      if (activeCard && audio && !audio.paused && boundaryRefreshDueAt && Date.now() >= boundaryRefreshDueAt) {
        clearActivePlayback('Rechecking current access.', 'loading');
      }
      scheduleAvailability();
    }
    else if (!activeCard || !audio || audio.paused) {
      if (boundaryRefreshTimer) clearTimeout(boundaryRefreshTimer);
      boundaryRefreshTimer = 0;
      boundaryRefreshDueAt = 0;
    }
  });

  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) { record.addedNodes.forEach(function (node) { if (node.nodeType === 1) enhance(node); }); });
    releaseDetachedCard();
  });
  function boot() { mountFloatingPlayer(); enhance(document); observer.observe(document.body, { childList: true, subtree: true }); openComposerFromQuery(); }
  window.addEventListener('scroll', scheduleFloatingPlayer, { passive: true });
  window.addEventListener('resize', scheduleFloatingPlayer, { passive: true });
  window.DSDOriginalsSocialCardLIBP01 = { canonical: canonical, referenceFromUrl: referenceFromUrl, enhance: enhance, pageBinding: pageBinding, acquireSharedAudio: acquireSharedAudio };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot, { once: true }) : boot();
})();
